import { AudienceSegment } from '@components/shared/CampaignAnalytics/ChartDefinitions/AudienceProfile';

const AUDIENCE_GROUP_SEPARATOR = /[_>]/;
const NAME_SEPARATOR = ' > ';

export const truncateAudienceGroupNames = (audiences: AudienceSegment[]) => {
  const lastValues = audiences.map(pair => {
    const splitName = pair.name
      .split(AUDIENCE_GROUP_SEPARATOR)
      .map(s => s.trim());
    return splitName.at(-1);
  });

  const duplicates = new Set(
    lastValues.filter((value, index, self) => {
      return self.indexOf(value) !== index;
    })
  );

  return audiences.map(pair => {
    const splitName = pair.name
      .split(AUDIENCE_GROUP_SEPARATOR)
      .map(s => s.trim());
    const last = splitName.at(-1);
    const secondLast = splitName.at(-2);
    if (last && secondLast && duplicates.has(last)) {
      return { ...pair, name: [secondLast, last].join(NAME_SEPARATOR) };
    } else if (last) {
      return { ...pair, name: last };
    }
    return pair;
  });
};
